var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilDeprecated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4491 7.54807L19.6482 9.34892C19.4646 9.53253 19.1677 9.53253 18.9841 9.34892L14.648 5.01281C14.4644 4.82921 14.4644 4.53233 14.648 4.34873L16.4489 2.54787C17.1794 1.81738 18.3669 1.81738 19.1013 2.54787L21.4491 4.89562C22.1835 5.62612 22.1835 6.81367 21.4491 7.54807ZM13.1011 5.89566L2.84286 16.1539L2.0147 20.9002C1.90141 21.5408 2.46003 22.0955 3.10068 21.9861L7.84696 21.1541L18.1052 10.8959C18.2888 10.7123 18.2888 10.4154 18.1052 10.2318L13.7691 5.89566C13.5816 5.71206 13.2847 5.71206 13.1011 5.89566ZM6.84692 15.2749C6.63207 15.0601 6.63207 14.7163 6.84692 14.5015L12.8628 8.48561C13.0776 8.27076 13.4214 8.27076 13.6363 8.48561C13.8511 8.70046 13.8511 9.04423 13.6363 9.25908L7.62039 15.2749C7.40554 15.4898 7.06178 15.4898 6.84692 15.2749ZM5.43671 18.5602H7.31179V19.9783L4.79215 20.4197L3.57726 19.2048L4.01869 16.6852H5.43671V18.5602Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilDeprecated);
export default __webpack_public_path__ + "static/media/pencil_deprecated.478b9de3b5dbde348f98c06280aa9820.svg";
export { ForwardRef as ReactComponent };